// extracted by mini-css-extract-plugin
export default {"heading":"NotFound_heading__t47nV","forwardButton":"NotFound_forwardButton__Y7wmW"};